import me from "models/me";
import { getStore } from "store";

export default function () {
    return function (nextState, replace, callback) {
        if (nextState.location.query.vp) {
            const store = getStore();
            const { scope } = store.getState();

            let valid = false;
            if (me && scope.brand) {
                const updateBrandPermission = me.hasPermission("update_brand");
                const updateProductPermission = me.hasPermission("update_product");
                const canManageInventoryPermission = me.hasPermission("can_manage_inventory");
                const canManageApi = me.hasPermission("manage_api");
                const canModifyPaymentAcct = me.hasPermission("modify_payment_account");
                const canEditOrderExportInfo = me.hasPermission("edit_order_export_info");
                const canAccessPromotionsUi =
                    me.hasPermission("enable_advanced_pricing") && me.hasPermission("promotions_access");

                const usePriceTemplates = scope.brand.hasPreference("use_pricing_templates");
                const dontPreloadProducts = scope.brand.hasPreference("dont_preload_products_into_admin");
                const noOrdersPref = scope.brand.hasPreference("no_orders");
                const allowCustomizations = scope.brand.hasPreference("allow_customizations");
                const linesheetPdfBuilder = scope.brand.hasPreference("linesheet_pdf_builder");

                const hasAPIModule = scope.brand.hasModuleEnabled("api");
                const hasPaymentsModule = scope.brand.hasModuleEnabled("payments");
                const buyerMarketplaceModule = scope.brand.hasModuleEnabled("buyer_marketplace");

                switch (nextState.location.query.vp) {
                    case "prodbanners":
                    case "bulkcompany":
                    case "bulkbuyer":
                    case "deliverywindows":
                    case "users":
                    case "usergroups":
                    case "brandedlogininfo":
                    case "info":
                    case "media_management":
                    case "archives":
                    case "bulkimage":
                        valid = updateBrandPermission;
                        break;
                    case "barcodeprinting":
                        valid = !dontPreloadProducts;
                        break;
                    case "dropboxmanagement":
                        valid = true;
                        break;
                    case "image_management":
                        valid = updateBrandPermission && !dontPreloadProducts;
                        break;
                    case "image_reports":
                    case "imagesettings":
                    case "bulkproduct":
                        valid = updateProductPermission;
                        break;
                    case "managecatalogs":
                        valid = linesheetPdfBuilder;
                        break;
                    case "bulkpricing":
                        valid = updateBrandPermission && usePriceTemplates;
                        break;
                    case "gallery":
                        valid = updateProductPermission && !dontPreloadProducts;
                        break;
                    case "bulkinventory":
                        valid = updateBrandPermission && canManageInventoryPermission;
                        break;
                    case "apimanagement":
                        valid = canManageApi && hasAPIModule;
                        break;
                    case "paymentprocessing":
                    case "paymenthistory":
                        valid = hasPaymentsModule && canModifyPaymentAcct;
                        break;
                    case "inventorysettingspage":
                        valid = updateBrandPermission && canManageInventoryPermission;
                        break;
                    case "orderpage":
                    case "ordersettingspage":
                        valid = updateBrandPermission && !noOrdersPref;
                        break;
                    case "managemarketplaceprofile":
                    case "onlinetradeshowsetup":
                        valid = updateBrandPermission && buyerMarketplaceModule;
                        break;
                    case "stitchlabsmanagement":
                        valid = true;
                        break;
                    case "branding":
                        valid = updateBrandPermission && allowCustomizations;
                        break;
                    case "orderexportinfo":
                        valid = canEditOrderExportInfo;
                        break;
                    case "promotions_access":
                        valid = canAccessPromotionsUi;
                        break;
                    default:
                        valid = false;
                }
                if (valid) {
                    callback();
                } else {
                    replace({
                        pathname: "/404",
                    });
                    callback();
                }
            } else {
                replace({ pathname: "/login" });
            }
        } else {
            callback();
        }
    };
}
